import React, { useEffect, useRef, useState } from 'react';
import {
  Grid,
  styled,
  TextField,
  Paper,
  Button,
  Typography,
  TableRow,
  TableCell,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Autocomplete
} from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Gate, GateGroup, ShiftType } from '../../../schema/gate';
import IOSSwitch from '../../../components/IOSSwitch';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Box } from '@mui/system';
import GateFromInput from '../../../components/formInput/GateFromInput';
import { api } from '../../../api';
import AreaCodeFromInput from '../../../components/formInput/AreaCodeFromInput';
import { Area } from '../../../schema/area';
import { Company } from '../../../schema/company';
import { PersonType } from '../../../schema/person';
import SearchIcon from '@mui/icons-material/Search';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import MultiSelect from '../../../components/MultiSelect';
import { CircularProgress } from '@mui/material';
import { CardType } from '../../../schema/card';
import OnlinePersonTable from './OnlinePersonTable';

const tableGateHead = ['ประตู', 'พื่นที่', 'สถานะ', 'เวลาเปิด-ปิด', 'ลบประตู'];
const personHead = ['เลขบัตรประชาชน', 'ชื่อ นามสกุล', 'ประเภท', 'บริษัท', ''];
const EditGateGroup: React.FC = () => {
  const { gate_group_id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState<string>('');
  const [areaID, setAreaID] = useState<number | null>(null);
  const [shiftTypeID, setShiftTypeID] = useState<number | null>(null);

  const ref = useRef<string>();

  const [filterID, setFilterID] = useState<string>('');
  const [filterName, setFilterName] = useState<string>('');
  const [filterCrop, setFilterCrop] = useState<string>('');
  const [filterCompanyIDList, setFilterCompanyIDList] = useState<number[]>([]);
  const [filterCompanyList, setFilterCompanyList] = useState<Company[]>([]);
  const [filterPersonTypeIDList, setFilterPersonTypeIDList] = useState<string[] | number[]>([]);

  const [companies, setCompanies] = useState<Company[]>([]);
  const [companySearchKeyword, setCompanySearchKeyword] = useState<string>('');

  const [personTypes, setPersonTypes] = useState<PersonType[]>([]);

  const [gateIds, setGateIds] = useState<number[]>([]);
  const [gateName, setGateName] = useState<string>('');

  const [gates, setGates] = useState<Gate[]>([]);
  const [persons, setPersons] = useState<{
    total: number;
    limit: number;
    offset: number;
    data: [
      {
        id: number;
        company_id: number;
        email: string;
        employee_code: string;
        first_name: string;
        last_name: string;
        title_name: string;
        phone_number: string;
        personnal_id: string;
        person_type: any;
        company: any;
      }
    ];
  }>({
    total: 0,
    limit: 0,
    offset: 0,
    data: [
      {
        id: 0,
        company_id: 0,
        email: '',
        employee_code: '',
        first_name: '',
        last_name: '',
        title_name: '',
        phone_number: '',
        personnal_id: '',
        person_type: {},
        company: {}
      }
    ]
  });

  const [personsNew, setPersonsNew] = useState<{
    total: number;
    limit: number;
    offset: number;
    data: [
      {
        id: number;
        company_id: number;
        email: string;
        employee_code: string;
        first_name: string;
        last_name: string;
        title_name: string;
        phone_number: string;
        personnal_id: string;
        person_type: any;
        company: any;
      }
    ];
  }>({
    total: 0,
    limit: 0,
    offset: 0,
    data: [
      {
        id: 0,
        company_id: 0,
        email: '',
        employee_code: '',
        first_name: '',
        last_name: '',
        title_name: '',
        phone_number: '',
        personnal_id: '',
        person_type: {},
        company: {}
      }
    ]
  });

  const [open, setOpen] = useState(false);
  const [openPerson, setOpenPerson] = useState(false);
  const [filterAreaID, setFilterAreaID] = useState<number | null>(null);

  const [shiftTypeList, setShiftTypeList] = useState<ShiftType[]>([]);
  const [areaName, setAreaName] = useState<string>('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [pageNew, setPageNew] = useState(0);
  const [rowsPerPageNew, setRowsPerPageNew] = useState(10);

  const [pageDoor, setPageDoor] = useState(0);
  const [rowsPerPageDoor, setRowsPerPageDoor] = useState(10);

  const [totalDoor, setTotalDoor] = useState(0);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDoor, setIsLoadingDoor] = useState<boolean>(false);
  const [isLoadingNew, setIsLoadingNew] = useState<boolean>(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState<boolean>(false);

  const [searchKeywordArea, setSearchKeywordArea] = useState<string>('');
  const [areaList, setAreaList] = useState<Area[]>([]);
  const [selectedValueArea, setSelectedValueArea] = useState<Area[]>([]);

  const [cardTypeList, setcardTypeList] = useState<CardType[]>([]);
  const [selectedValuecardType, setSelectedValuecardType] = useState<CardType[]>([]);

  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const removeGateFromGroup = (id: number | null) => {
    if (id != null) {
      const temp = gateIds.reduce<number[]>((result, data) => {
        if (data != id) {
          result.push(data);
        }
        return result;
      }, []);
      setGateIds(temp);
      api.delete<any>(`/gate-group/${gate_group_id}/${id}`, {}).then((res) => {
        const { data } = res;
        console.log(data);
      });
    }
  };
  const addGateToGroup = (id: number | null) => {
    if (id != null) {
      if (!gateIds.find((data) => data == id)) {
        setGateIds([...gateIds, id].sort());
      }
    }
  };

  const removePersonFromGroup = (id: number | null) => {
    if (id != null) {
      api.put<any>(`/gate-group/${gate_group_id}/persons/${id}`, {}).then((res) => {
        const { data } = res;
        refreshPerson();
      });
    }
  };

  const addPersonToGroup = (id: number | null) => {
    if (id != null) {
      api.post<any>(`/gate-group/${gate_group_id}/persons/${id}`, {}).then((res) => {
        const { data } = res;
        refreshPerson();
      });
    }
  };

  const refreshPerson = () => {
    setIsLoading(true);
    setIsLoadingNew(true);

    const searchParams = new URLSearchParams();
    const searchParamsNew = new URLSearchParams();

    if (filterID) {
      searchParams.set('personnal_id', filterID);
      searchParamsNew.set('personnal_id', filterID);
    }
    if (filterName) {
      searchParams.set('name', filterName);
      searchParamsNew.set('name', filterName);
    }
    if (filterCompanyIDList.length) {
      filterCompanyIDList.forEach((company_id) => {
        searchParams.append('company_id', `${company_id}`);
        searchParamsNew.append('company_id', `${company_id}`);
      });
    }
    if (filterPersonTypeIDList.length) {
      filterPersonTypeIDList.forEach((person_type_id) => {
        searchParams.append('person_type_id', `${person_type_id}`);
        searchParamsNew.append('person_type_id', `${person_type_id}`);
      });
    }
    searchParams.set('offset', `${page * rowsPerPage}`);
    searchParams.set('limit', `${rowsPerPage}`);

    api
      .get<any>(`/gate-group/${gate_group_id}/persons`, { params: searchParams })
      .then((res) => {
        const { data } = res;
        setPersons(data);
      })
      .finally(() => setIsLoading(false));

    searchParamsNew.set('offset', `${pageNew * rowsPerPageNew}`);
    searchParamsNew.set('limit', `${rowsPerPageNew}`);

    api
      .get<any>(`/gate-group/${gate_group_id}/persons_new`, { params: searchParamsNew })
      .then((res) => {
        const { data } = res;
        setPersonsNew(data);
      })
      .finally(() => setIsLoadingNew(false));
  };

  const handleFormSubmit = () => {
    if (isLoading) {
      return;
    }
    if (gate_group_id && areaID && shiftTypeID) {
      setIsLoading(true);
      api
        .put(`/gate-group/${gate_group_id}`, {
          group_name: name,
          area_id: areaID,
          shift_type_id: shiftTypeID,
          gates: gateIds,
          areas: selectedValueArea.map((select_area) => select_area.id),
          card_types: selectedValuecardType.map((select_cardType) => select_cardType.id)
        })
        .then(() => {
          navigate('/gate-group');
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleDelete = () => {
    if (isLoadingDelete) {
      return;
    }
    if (gate_group_id) {
      setIsLoadingDelete(true);
      api
        .delete(`/gate-group/${gate_group_id}`)
        .then(() => {
          navigate('/gate-group');
        })
        .finally(() => setIsLoadingDelete(false));
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event: React.SyntheticEvent<unknown>, reason?: string) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  const handleClickOpenPerson = () => {
    if (openPerson) {
      setOpenPerson(false);
    } else {
      setOpenPerson(true);
      setIsLoadingNew(true);
      const searchParams = new URLSearchParams();
      searchParams.set('offset', `${pageNew * rowsPerPageNew}`);
      searchParams.set('limit', `${rowsPerPageNew}`);
      api
        .get<any>(`/gate-group/${gate_group_id}/persons_new`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setPersonsNew(data);
        })
        .finally(() => setIsLoadingNew(false));
    }
  };

  const handleExportCSVFile = () => {
    if (isExportLoading) {
      return;
    }
    
    const searchParams = new URLSearchParams();

    if (filterID) {
      searchParams.set('personnal_id', filterID);
    }
    if (filterName) {
      searchParams.set('name', filterName);
    }
    if (filterCompanyIDList.length) {
      filterCompanyIDList.forEach((company_id) => {
        searchParams.append('company_id', `${company_id}`);
      });
    }
    if (filterPersonTypeIDList.length) {
      filterPersonTypeIDList.forEach((person_type_id) => {
        searchParams.append('person_type_id', `${person_type_id}`);
      });
    }
    setIsExportLoading(true);
    api
      .get(`/gate-group/${gate_group_id}/persons/export`, {
        params: searchParams,
        responseType: 'blob'
      })
      .then((response) => {
        const today = new Date();
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          'gate_group_' +
            gate_group_id +
            '_person_export_data_' +
            today.toLocaleDateString('en-US') +
            '.xlsx'
        );
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => setIsExportLoading(false));
  };

  useEffect(() => {
    api.get<GateGroup>(`/gate-group/${gate_group_id}`).then((res) => {
      const { data } = res;
      setName(data.group_name);
      setAreaID(data.area_id);
      setAreaName(data.area?.area_name);
      setShiftTypeID(data.shift_type_id ? data.shift_type_id : null);

      if (data.gates) {
        setGateIds(data.gates.map((data) => data.id));
      }
      if (data.areas) {
        setSelectedValueArea(data.areas);
      }
      if (data.card_types) {
        setSelectedValuecardType(data.card_types);
      }
    });

    api.get<CardType[]>(`/card_type?has_wpm=true&has_ost=true`).then((res) => {
      const { data } = res;
      setcardTypeList(data);
    });
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams();
    searchParams.set('offset', `${page * rowsPerPage}`);
    searchParams.set('limit', `${rowsPerPage}`);
    api.get<any>(`/gate-group/${gate_group_id}/persons`, { params: searchParams }).then((res) => {
      const { data } = res;
      setPersons(data);
    });
  }, []);

  useEffect(() => {
    setIsLoadingDoor(true);
    if (gateIds.length == 0) {
      setGates([]);
      setIsLoadingDoor(false);
      return;
    }
    const searchParams = new URLSearchParams();
    gateIds.forEach((gate_id) => {
      searchParams.append('id', `${gate_id}`);
    });
    searchParams.append('name', `${gateName}`);
    searchParams.append('limit', `${rowsPerPageDoor}`);
    searchParams.append('offset', `${pageDoor * rowsPerPageDoor}`);
    api
      .get<Gate[]>(`/gate`, { params: searchParams })
      .then((res) => {
        const { data } = res;
        setGates(data);
        if (gateName != '') {
          setPageDoor(0);
        }
      })
      .finally(() => setIsLoadingDoor(false));
  }, [gateIds, gateName, rowsPerPageDoor, pageDoor]);

  useEffect(() => {
    if (areaID) {
      api.get<Area>(`/area/${areaID}`).then((res) => {
        const { data } = res;
        setAreaName(data.area_name);
      });
      return;
    }
    setAreaName('');
  }, [areaID]);

  useEffect(() => {
    api.get<ShiftType[]>(`/shift_type`).then((res) => {
      const { data } = res;
      setShiftTypeList(data);
    });
  }, []);

  const handlePageChangeNew = (_: unknown, newPage: number) => {
    setPageNew(newPage);
  };

  const handleRowsPerPageChangeNew = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPageNew(+event.target.value);
    setPageNew(0);
  };

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handlePageChangeDoor = (_: unknown, newPage: number) => {
    setPageDoor(newPage);
  };

  const handleRowsPerPageChangeDoor = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPageDoor(+event.target.value);
    setPageDoor(0);
  };

  useEffect(() => {
    setIsLoading(true);
    const timeOutId = setTimeout(() => {
      ref.current = JSON.stringify({
        filterID,
        filterName,
        filterCompanyIDList,
        filterPersonTypeIDList,
        page,
        rowsPerPage
      });
      const searchParams = new URLSearchParams();

      if (filterID) {
        searchParams.set('personnal_id', filterID);
      }
      if (filterName) {
        searchParams.set('name', filterName);
      }
      if (filterCompanyIDList.length) {
        filterCompanyIDList.forEach((company_id) => {
          searchParams.append('company_id', `${company_id}`);
        });
      }
      if (filterPersonTypeIDList.length) {
        filterPersonTypeIDList.forEach((person_type_id) => {
          searchParams.append('person_type_id', `${person_type_id}`);
        });
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);

      api
        .get<any>(`/gate-group/${gate_group_id}/persons`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setPersons(data);
        })
        .finally(() => setIsLoading(false));
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [filterID, filterName, filterCompanyIDList, filterPersonTypeIDList, page, rowsPerPage]);

  useEffect(() => {
    setIsLoadingNew(true);
    const timeOutId = setTimeout(() => {
      ref.current = JSON.stringify({
        filterID,
        filterName,
        filterCompanyIDList,
        filterPersonTypeIDList,
        page,
        rowsPerPage
      });
      const searchParams = new URLSearchParams();

      if (filterID) {
        searchParams.set('personnal_id', filterID);
      }
      if (filterName) {
        searchParams.set('name', filterName);
      }
      if (filterCompanyIDList.length) {
        filterCompanyIDList.forEach((company_id) => {
          searchParams.append('company_id', `${company_id}`);
        });
      }
      if (filterPersonTypeIDList.length) {
        filterPersonTypeIDList.forEach((person_type_id) => {
          searchParams.append('person_type_id', `${person_type_id}`);
        });
      }
      searchParams.set('offset', `${pageNew * rowsPerPageNew}`);
      searchParams.set('limit', `${rowsPerPageNew}`);

      api
        .get<any>(`/gate-group/${gate_group_id}/persons_new`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setPersonsNew(data);
        })
        .finally(() => setIsLoadingNew(false));
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [filterID, filterName, filterCompanyIDList, filterPersonTypeIDList, pageNew, rowsPerPageNew]);

  useEffect(() => {
    api.get<PersonType[]>(`/person-type`).then((res) => {
      const { data } = res;
      setPersonTypes(data);
    });
  }, []);

  useEffect(() => {
    if (companySearchKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('company_name', companySearchKeyword);
        searchParams.set('limit', '25');

        api.get<Company[]>(`/company`, { params: searchParams }).then((res) => {
          const { data } = res;
          setCompanies(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    } else {
      api
        .get<Company[]>(`/company`, {
          params: {
            limit: 25
          }
        })
        .then((res) => {
          const { data } = res;
          setCompanies(data);
        });
    }
  }, [companySearchKeyword]);

  useEffect(() => {
    if (searchKeywordArea) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('nameorcode', searchKeywordArea);
        searchParams.set('limit', '10');
        api.get<Area[]>(`/area`, { params: searchParams }).then((res) => {
          const { data } = res;
          setAreaList(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    } else {
      api.get<Area[]>(`/area`, { params: { limit: 10 } }).then((res) => {
        const { data } = res;
        setAreaList(data);
      });
    }
  }, [searchKeywordArea]);

  return (
    <RootContainer>
      <PageHeader text="แก้ไขกลุ่มประตู" />

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button component={Link} to={`/gate-group`} sx={{ my: 3, p: 0 }}>
            <ArrowBackIosIcon />
            กลุ่มประตู
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Grid container columns={2} spacing={2} direction={'row-reverse'}>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ marginTop: 2 }}
                onClick={() => handleFormSubmit()}
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress color="primary" size={'1.25rem'} sx={{ mr: 2 }} />
                ) : null}
                {`บันทึก`}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="error"
                sx={{ marginTop: 2 }}
                onClick={() => handleDelete()}
                // onClick={handleDelete}
                disabled={isLoadingDelete}
              >
                {isLoadingDelete ? (
                  <CircularProgress color="primary" size={'1.25rem'} sx={{ mr: 2 }} />
                ) : null}
                {`ลบ`}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Paper>
        <Typography variant="h6" sx={{ px: 2, py: 2 }}>
          {'แก้ไขข้อมูล'}
        </Typography>
        <Form sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่อกลุ่ม"
                variant="outlined"
                placeholder="ชื่อกลุ่ม"
                name="group_name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>{`ช่วงเวลา เปิด-ปิด`}</InputLabel>
                <Select
                  label={`ช่วงเวลา เปิด-ปิด`}
                  variant="outlined"
                  onChange={(e) => {
                    const parsed = parseInt(e.target.value);
                    if (isNaN(parsed)) {
                      setShiftTypeID(null);
                      return;
                    }
                    setShiftTypeID(parsed);
                  }}
                  value={shiftTypeID != null ? `${shiftTypeID}` : ''}
                  autoComplete="off"
                  required
                >
                  {shiftTypeList.map((data, index) => (
                    <MenuItem key={index} value={`${data.id}`}>
                      {`${data.open_time?.substring(0, 5)} - ${data.close_time?.substring(0, 5)} (${
                        data.type_name
                      })`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={areaList}
                getOptionLabel={(option) =>
                  option?.area_code ? option.area_name + ' (' + option.area_code + ')' : ''
                }
                renderInput={(params) => <TextField {...params} label="รหัสพื่นที่" />}
                onChange={(_, value) => setSelectedValueArea(value)}
                value={selectedValueArea}
                onInputChange={(_, newInputValue) => {
                  setSearchKeywordArea(newInputValue);
                }}
                // isOptionEqualToValue={(option, v) => v?.id == option?.id}
                fullWidth
                multiple={true}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={cardTypeList}
                getOptionLabel={(option) => (option?.type_name ? option.type_name : '')}
                renderInput={(params) => <TextField {...params} label="ประเภทบัตร" />}
                onChange={(_, value) => setSelectedValuecardType(value)}
                value={selectedValuecardType}
                fullWidth
                multiple={true}
              />
            </Grid>
            {/* <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่อพื้นที่"
                variant="outlined"
                placeholder="ชื่อพื้นที่"
                value={areaName ? areaName : ''}
                InputProps={{ readOnly: true }}
                disabled={true}
                sx={
                  areaName
                    ? {
                      '.Mui-disabled': {
                        color: 'black',
                        opacity: 1,
                        '-webkit-text-fill-color': 'black'
                      },
                      '.MuiInputLabel-root': {
                        color: '#65748B',
                        '-webkit-text-fill-color': '#65748B'
                      }
                    }
                    : null
                }
              />
            </Grid> */}
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 2 }}>
                    แก้ไขประตูที่อยู่ในกลุ่ม
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ paddingTop: 2, paddingBottom: 2 }}>
                <Grid item md={4}>
                  <TextField
                    id="search-text-label"
                    variant="outlined"
                    placeholder="ค้นหาประตู"
                    onChange={(event) => setGateName(event.target.value)}
                    fullWidth
                    value={gateName}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item md={4} sx={{ alignSelf: 'center' }}>
                  <Button
                    variant="outlined"
                    startIcon={<AddCircleIcon />}
                    onClick={handleClickOpen}
                  >
                    เพิ่มประตู
                  </Button>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Table
                    heads={tableGateHead}
                    count={gateIds.length}
                    page={pageDoor}
                    rowsPerPage={rowsPerPageDoor}
                    onPageChange={handlePageChangeDoor}
                    onRowsPerPageChange={handleRowsPerPageChangeDoor}
                    isLoading={isLoadingDoor}
                  >
                    {gates.length == 0 && (
                      <TableRow>
                        <TableCell colSpan={7} align="center" sx={{ p: 1 }}>
                          <Typography>ไม่พบข้อมูลรายการประตู</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                    {gates.map((data, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">{data.gate_name}</TableCell>
                        <TableCell align="center">{data.area?.area_name}</TableCell>
                        <TableCell align="center">
                          <IOSSwitch checked={data.is_active} disabled />
                        </TableCell>
                        <TableCell align="center">
                          {data.shift_type
                            ? `${data.shift_type?.open_time?.substring(
                                0,
                                5
                              )} - ${data.shift_type?.close_time?.substring(0, 5)} (${
                                data.shift_type?.type_name
                              })`
                            : ''}
                        </TableCell>
                        <TableCell align="center">
                          <Grid container spacing={2} justifyContent="center">
                            <Grid item>
                              <IconButton onClick={() => removeGateFromGroup(data.id)}>
                                <DeleteIcon fontSize="large" color="error" />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))}
                  </Table>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      </Paper>
      <Paper sx={{ mt: 3 }}>
        <Typography variant="h6" sx={{ px: 2, py: 2 }}>
          {'บุคคลในค่าเริ่มต้นกลุ่มประตู'}
          <Button
            sx={{ ml: 2 }}
            variant="outlined"
            color="primary"
            onClick={handleExportCSVFile}
            disabled={isExportLoading}
          >
            Export
          </Button>
        </Typography>
        <Grid container spacing={2} sx={{ padding: 2 }}>
          <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="เลขบัตรประชาชน"
              variant="outlined"
              placeholder="เลขบัตรประชาชน"
              onChange={(event) => setFilterID(event.target.value)}
              fullWidth
              value={filterID}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="ค้นหาชื่อ - นามสกุล"
              variant="outlined"
              placeholder="ค้นหาชื่อ - นามสกุล"
              value={filterName}
              onChange={(event) => setFilterName(event.target.value)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          {/* <Grid item md={3}>
            <MultiSelect
              options={personTypes.map((data) => ({ id: data.id.toString(), name: data.type_name }))}
              onChange={(data) => setFilterPersonTypeIDList(data)}
              label="ประเภทบุคคล"
            />
          </Grid> */}
          <Grid item md={3}>
            <Autocomplete
              multiple
              limitTags={2}
              disablePortal
              options={companies}
              getOptionLabel={(option) => (option?.company_name ? option.company_name : '')}
              renderInput={(params) => (
                <TextField {...params} label="บริษัท" placeholder="บริษัท" />
              )}
              onChange={(_, value) => {
                setCompanySearchKeyword('');
                setFilterCompanyIDList(value.map((data) => data.id));
                setFilterCompanyList(value);
              }}
              value={filterCompanyList}
              onInputChange={(_, newInputValue) => {
                setCompanySearchKeyword(newInputValue);
              }}
              isOptionEqualToValue={(option, v) => v?.id == option?.id}
              fullWidth
            />
          </Grid>
          <Grid item md={3} sx={{ alignSelf: 'center' }}>
            {openPerson ? (
              <Button
                variant="contained"
                startIcon={<AddCircleIcon />}
                onClick={handleClickOpenPerson}
              >
                เพิ่มบุคคล
              </Button>
            ) : (
              <Button
                variant="outlined"
                startIcon={<AddCircleIcon />}
                onClick={handleClickOpenPerson}
              >
                เพิ่มบุคคล
              </Button>
            )}
          </Grid>
        </Grid>
        {openPerson && (
          <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid item xs={12}>
              <Table
                heads={personHead}
                count={personsNew.total}
                page={pageNew}
                rowsPerPage={rowsPerPageNew}
                onPageChange={handlePageChangeNew}
                onRowsPerPageChange={handleRowsPerPageChangeNew}
                isLoading={isLoadingNew}
              >
                {personsNew.data.length <= 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ p: 1 }}>
                      <Typography>ไม่พบข้อมูลรายการบุคคล</Typography>
                    </TableCell>
                  </TableRow>
                )}
                {personsNew.data.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">
                      {data.employee_code ? data.employee_code : data.personnal_id}
                    </TableCell>
                    <TableCell align="center">
                      {data.title_name + ' ' + data.first_name + ' ' + data.last_name}
                    </TableCell>
                    <TableCell align="center">{data.person_type?.type_name}</TableCell>
                    <TableCell align="center">{data.company?.company_name}</TableCell>
                    <TableCell align="center">
                      <IconButton onClick={() => addPersonToGroup(data.id)} sx={{ padding: 0 }}>
                        <AddCircleIcon fontSize="medium" color="success" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </Table>
            </Grid>
          </Grid>
        )}
        <Grid container spacing={2} sx={{ padding: 2 }}>
          <Grid item xs={12}>
            <Table
              heads={personHead}
              count={persons.total}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              isLoading={isLoading}
            >
              {persons.data.length <= 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ p: 1 }}>
                    <Typography>ไม่พบข้อมูลรายการบุคคล</Typography>
                  </TableCell>
                </TableRow>
              )}
              {persons.data.map((data, index) => (
                <TableRow key={index}>
                  <TableCell align="center">
                    {data.employee_code ? data.employee_code : data.personnal_id}
                  </TableCell>
                  <TableCell align="center">
                    {data.title_name + ' ' + data.first_name + ' ' + data.last_name}
                  </TableCell>
                  <TableCell align="center">{data.person_type?.type_name}</TableCell>
                  <TableCell align="center">{data.company?.company_name}</TableCell>
                  <TableCell align="center">
                    <IconButton onClick={() => removePersonFromGroup(data.id)} sx={{ padding: 0 }}>
                      <DeleteIcon fontSize="medium" color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </Grid>
        </Grid>
      </Paper>

      <OnlinePersonTable/>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogTitle>เพิ่มประตูในกลุ่ม</DialogTitle>
        <DialogContent sx={{ px: 2, pb: 0 }}>
          <Box component="form" sx={{ display: 'flex', minWidth: 400, p: 1 }}>
            <GateFromInput
              value={filterAreaID}
              onChange={(value) => setFilterAreaID(value)}
              gateIds={gateIds}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>ยกเลิก</Button>
          <Button
            onClick={(e) => {
              addGateToGroup(filterAreaID);
              setFilterAreaID(null);
              handleClose(e);
            }}
          >
            เพิ่มข้อมูล
          </Button>
        </DialogActions>
      </Dialog>
    </RootContainer>
  );
};

export default EditGateGroup;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
